import type {
  GoodsReceiptDto,
  JobMaterialShortageDto,
  PurchaseOrderDto,
  SupplierDto,
} from "@grizzly/shared";
import { request } from "../http.js";

export const purchasingApi = {
  listSuppliers: () => request<{ items: SupplierDto[] }>("/suppliers"),
  createSupplier: (input: object) =>
    request<{ supplier: SupplierDto }>("/suppliers", { method: "POST", body: input }),
  listPurchaseOrders: () => request<{ items: PurchaseOrderDto[] }>("/purchase-orders"),
  getPurchaseOrder: (id: string) =>
    request<{ order: PurchaseOrderDto; receipts: GoodsReceiptDto[] }>(
      `/purchase-orders/${id}`
    ),
  createPurchaseOrder: (input: object) =>
    request<{ order: PurchaseOrderDto }>("/purchase-orders", {
      method: "POST",
      body: input,
    }),
  receivePurchaseOrder: (id: string, input: object) =>
    request<{ order: PurchaseOrderDto }>(`/purchase-orders/${id}/receive`, {
      method: "POST",
      body: input,
    }),
  cancelPurchaseOrder: (id: string) =>
    request<{ order: PurchaseOrderDto }>(`/purchase-orders/${id}/cancel`, {
      method: "POST",
      body: {},
    }),
  listJobShortages: (jobId: string) =>
    request<{ items: JobMaterialShortageDto[] }>(`/jobs/${jobId}/shortages`),
};
